import { theme } from '@frontend/theme';
import { SpinningLoader } from '@frontend/design-system';

export const InsuranceSpinnerLoader = () => {
  return (
    <div css={{ padding: theme.spacing(2), textAlign: 'center' }}>
      <SpinningLoader />
    </div>
  );
};
